import React from 'react';
import { Box, Typography } from '@mui/material';
import Label from '../Label';
import { AiOutlinePaperClip } from 'react-icons/ai';
import moment from 'moment';
import { announcementTypes } from '../utils';
import type Announcement from '@/types/database/announcement';

const AnnounceListItem: React.FC<{
  item: Announcement;
  labelElement: string;
  categoryMenu: { id: string; name: string; color: string }[];
  onClick: () => void;
}> = ({ item, onClick, labelElement, categoryMenu }) => {
  const { content } = item;

  const contentSlice =
    content.length > 45 ? `${content.slice(0, 45)}...` : content;

  const selectedCategory = categoryMenu.find(
    (category) => category.name === labelElement
  );

  return (
    <Box
      sx={{
        width: '100%',
        py: '1.5rem',
        display: 'flex',
        flexDirection: 'column',
        '& > *:not(:last-of-type)': {
          mb: '0.5rem',
        },
      }}
      onClick={onClick}
    >
      <Box
        sx={{
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center',
        }}
      >
        <Box
          sx={{
            display: 'flex',
            alignItems: 'center',
            '& > *:not(:last-of-type)': {
              mr: '0.5rem',
            },
          }}
        >
          <Label type={selectedCategory} />
          {item.checkedStatus && (
            <Label
              type={announcementTypes.find((type) => type.name === '置頂')}
            />
          )}
          {item.files.length > 0 && <AiOutlinePaperClip />}
        </Box>
        <Typography
          variant="body1"
          sx={{
            justifySelf: 'flex-end',
          }}
        >
          {moment(item.announcementTime).format('YYYY-MM-DD')}
        </Typography>
      </Box>
      <Typography variant="h1">{item.title}</Typography>
      <Typography variant="body1">{contentSlice}</Typography>
    </Box>
  );
};

export default AnnounceListItem;
